import React, { Component } from "react";
import "./instructions.css";
import Interweave from "interweave";

class Instructions extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <Interweave content={this.props.description} />
            </div>
        );
    }
}

export default Instructions;
